import React, {useState, useEffect} from 'react'
import { Helmet } from 'react-helmet'
import Sidebar from '../../components/User/Sidebar/Sidebar'
import Supportform from '../../components/User/supportfrom/Supportform'
import Topbar from '../../components/User/Topbar/Topbar';
const axios = require('axios');
const constants = require('../../constant');

export default function UserSupport() {
  const [teacherDetails, setteacherDetails] = useState({});
  useEffect(async () => {
      async function verify() {
          const token = localStorage.getItem("token");
          if (!token) {
              window.location.href = "/";
          } else {
              const result = await axios({
                  method: "post",
                  url: `${constants.backendUrl}/verifyTeacher`,
                  headers: {
                      "Content-Type": "application/json",
                      "x-auth-token": token,
                  },
                  data: {
                      token: token,
                  },
              });
              console.log(result);
              if (!result.data.success) {
                  localStorage.removeItem("token");
                  window.location.href = "/";
              } else {
                  setteacherDetails(result.data.teacher);
              }
          }
      }
      verify();
      console.log(teacherDetails);
  }, []);

  useEffect(() => {
      console.log(teacherDetails);
  }, [teacherDetails]);

  return (
      <div>
          <Helmet>
              <script defer src="assets/vendors/scripts/script.min.js"></script>
          </Helmet>
          <Topbar teacherDetails={teacherDetails} />
          <Sidebar teacherDetails={teacherDetails} />
          <Supportform />
      </div>
  );
}
